export default __webpack_public_path__ + "static/media/m-signup-15-tour-pg-2.f4e815aa.jpg";